export { AdultosOnboardingWelcome } from "./AdultosOnboardingWelcome";
